import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';

@Entity('deheading_rates')
export class DeheadingRatesEntity {
    @PrimaryGeneratedColumn('increment', { name: 'deheading_rates_id' })
    deheadingRatesId: number;

    @Column('varchar', {
        nullable: false,
        length: 50,
        name: 'contractor_name',
    })
    contractorName: string;

    @Column('varchar', {
        nullable: false,
        length: 30,
        name: 'count',
    })
    count: string;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: "bill_type"
    })
    billType: string;

    @Column('decimal', {
        nullable: false,
        precision: 10,
        scale: 2,
        name: "rate"
    })
    rate: string;

    @Column('int', {
        nullable: false,
        name: 'contractor_id',
    })
    contractorId: number;

    @Column('int', {
        nullable: false,
        name: 'min_count',
        default: 0,  // Ensure default value is not null
    })
    minCount: number;

    @Column('int', {
        nullable: false,
        name: 'max_count',
        default: 0,  // Ensure default value is not null
    })
    maxCount: number;
}
